const GENERIC_TEMPLATES_DYNAMIC_TOKEN_TYPES = {
  RECIPIENT: 'Recipient',
  DOCUMENT: 'Document',
  PAYMENT: 'Payment',
  CONTACT: 'Contact',
  E_SIGNATURE: 'E_Signature',
} as const;

export default GENERIC_TEMPLATES_DYNAMIC_TOKEN_TYPES;
